<div class="app-background-container">
  <ng-container *ngIf="uiState$ | async as state">
    <p-card *ngIf="state.inviteDetails && !state.error && !state.accepted"
      header="{{ 'ACCEPT_INVITATION' | translate }}" styleClass="surface-card p-4 shadow-2 border-round">
      <div class="text-center">
        <span class="invite-icon-wrapper mb-3">
          <i class="pi pi-envelope big-invite-icon"></i>
        </span>
        <p>{{ 'INVITED_TO_JOIN' | translate }} <strong>{{ state.inviteDetails.organisationName }}</strong>.</p>
        <p>{{ 'YOUR_EMAIL' | translate }} <strong>{{ state.inviteDetails.inviteEmail }}</strong></p>

        <div class="mt-4">
          <ng-container *ngIf="state.isUserAuthenticated; else unauthenticatedActions">
            <button pButton [label]="'ACCEPT_INVITATION' | translate" icon="pi pi-check" (click)="acceptInvite()"
              class="w-full"></button>
            <button pButton [label]="'CANCEL' | translate" icon="pi pi-times" (click)="cancelInvite()"
              class="p-button-secondary w-full mt-2"></button>
          </ng-container>
          <ng-template #unauthenticatedActions>
            <p class="mb-3 text-xl font-bold text-primary">{{ 'TO_ACCEPT_INVITE' | translate }} <strong>{{
                state.inviteDetails.inviteEmail }}</strong>.</p>
            <div class="flex flex-column gap-2">
              <button pButton [label]="'ACCEPT_AND_SIGN_UP' | translate" icon="pi pi-user-plus"
                (click)="signUpAndAccept()"></button>
              <button pButton [label]="'ACCEPT_AND_SIGN_IN' | translate" icon="pi pi-sign-in"
                (click)="signInAndAccept()" class="p-button-outlined"></button>
            </div>
          </ng-template>
        </div>
      </div>
    </p-card>

    <p-card *ngIf="state.error" header="{{ 'INVITATION_ERROR' | translate }}"
      styleClass="surface-card p-4 shadow-2 border-round">
      <p class="text-red-500">{{ state.error }}</p>
      <div class="mt-4">
        <button pButton [label]="'GO_TO_HOME' | translate" icon="pi pi-home" routerLink="/home" class="w-full"></button>
      </div>
    </p-card>

    <p-card *ngIf="state.accepted && state.inviteDetails" header="{{ 'INVITATION_ACCEPTED' | translate }}"
      styleClass="surface-card p-4 shadow-2 border-round">
      <p>{{ 'SUCCESSFULLY_ACCEPTED' | translate }} <strong>{{ state.inviteDetails.organisationName }}</strong>.</p>
      <div class="mt-4">
        <button pButton [label]="'GO_TO_HOME' | translate" icon="pi pi-home" routerLink="/home" class="w-full"></button>
      </div>
    </p-card>

  </ng-container>
</div>